var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimming({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6A983",
    d: "M1.813 2.862h.018c.555 0 1.005-.325 1.005-.726 0-.4-.45-.725-1.005-.725C.33 1.777 0 3.027 0 3.427c0 .397 1.25-.545 1.813-.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6A983",
    d: "M.525 11.779l.078-.013a8.687 8.687 0 0 0 1.845-.484c-.61.28-1.245.465-1.923.497zm6.334-8.186c1.077.163 1.551 1.013 1.728 2.201L8.6 5.79c.05-.014.235-.046.323.227.146-.739.363-1.318.653-1.739l.003.001c.777.21 2.109.886 2.798 1.674a6.57 6.57 0 0 0 .119-.237c-.168.382-.42.81-.756 1.284-3.56-1.027-5.906 2.424-8.775 4.019-.203-.244-.567-.975-.668-1.816l.006-.003c1.943-.566 1.78-3.663 3.514-3.999-1.337-.955-1.408-2.513-2.66-2.71.256-.492-.148-.855-.445-1.239C4.48-.083 5.5 2.68 6.859 3.593z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131D26",
    d: "M2.028 9.325c-.982.453-1.575 1.312-1.777 2.58 1.008-.15 1.807-.41 2.467-.736-.198-.215-.587-.97-.69-1.844z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    d: "M12.505 5.786c.617-1.155.534-1.907-.413-2.331-.947-.425-1.88-.146-2.424.647.77.196 2.136.883 2.837 1.684zM2.508 13.08c4.652-1.332 6.133-7.098 11.674-3.403-5.38-6.194-9.601 3.92-13.798 3.485.564.209 1.272.182 2.124-.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    d: "M3.169 14.557c4.695-1.169 7.217-6.94 11.785-2.993-5.098-6.363-9.732 3.582-13.911 3 .556.23 1.265.227 2.126-.007z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimming);
export default __webpack_public_path__ + "static/media/swimming.c13c7a8fc09b69f347a33a7020288566.svg";
export { ForwardRef as ReactComponent };